import { render, staticRenderFns } from "./TestLog.vue?vue&type=template&id=5f0b8702&scoped=true&"
import script from "./TestLog.vue?vue&type=script&lang=js&"
export * from "./TestLog.vue?vue&type=script&lang=js&"
import style0 from "./TestLog.vue?vue&type=style&index=0&id=5f0b8702&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b8702",
  null
  
)

export default component.exports